import { RecognitionException, Parser, DefaultErrorStrategy } from "antlr4ts";
import {
    Recognizer,
    Token,
    ParserRuleContext,
    CharStream,
    IntStream,
} from "antlr4ts";
import {
    ProgramDeclarationContext,
    ProgContext,
    XLogoParser,
    InputLinesContext,
} from "./parser/XLogoParser";

export class ProcDeclRecoveryException extends RecognitionException {
    constructor(
        recognizer: Recognizer<Token, any>,
        input: CharStream | IntStream | undefined,
        ctx: ParserRuleContext | undefined,
        offendingToken: Token,
    ) {
        super(recognizer, input, ctx);
        this.setOffendingToken(recognizer, offendingToken);
    }
}

export class XLogoParserErrorStrategy extends DefaultErrorStrategy {
    private currentProg: string = "";
    private currProgHasError: boolean = false;

    public progsWithErrors: string[] = [];

    public sync(recognizer: Parser): void {
        //recognizer.context instanceof ProgContext
        if (recognizer.context instanceof ProgramDeclarationContext) {
            try {
                const currName = recognizer.context.Identifier();
                if (currName.text !== this.currentProg) {
                    this.currentProg = currName.text;
                    this.currProgHasError = false;
                }
            } catch {
                console.log("Unknown prog that has no name");
            }
        } else if (recognizer.context instanceof ProgContext) {
            if (this.currentProg) {
                if (this.currProgHasError) {
                    this.progsWithErrors.push(this.currentProg);
                }
            }

            this.currentProg = "";
            this.currProgHasError = false;
        }

        // Only applicable for program declarations
        if (this.currentProg) {
            // if the end was forgotten the rest of the code is interpreted as part of the current program
            // To prevent this we throw an error if we get a 'to' outside of ProgContext where it should be
            // the only place where it should appear
            if (
                recognizer.currentToken.type === XLogoParser.EOL &&
                recognizer.inputStream.LA(2) === XLogoParser.To &&
                !(recognizer.context instanceof ProgContext)
            ) {
                throw new ProcDeclRecoveryException(
                    recognizer,
                    recognizer.inputStream,
                    recognizer.context,
                    recognizer.inputStream.get(
                        recognizer.currentToken.tokenIndex + 1,
                    ),
                );
            }
            // No end at EOF
            if (
                !(recognizer.context instanceof ProgContext) &&
                recognizer.currentToken.type === XLogoParser.EOF
            ) {
                throw new ProcDeclRecoveryException(
                    recognizer,
                    recognizer.inputStream,
                    recognizer.context,
                    recognizer.currentToken,
                );
            }
        }

        super.sync(recognizer);
    }

    // Using the following method could be promising for syntax error classification

    public reportError(
        /*@NotNull*/ recognizer: Parser,
        /*@NotNull*/ e: RecognitionException,
    ): void {
        if (!(e instanceof ProcDeclRecoveryException)) {
            super.reportError(recognizer, e);
        } else {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            this.notifyErrorListeners(recognizer, "Missing end", e);
        }
    }

    public recover(recognizer: Parser, e: RecognitionException): void {
        if (!(e instanceof ProcDeclRecoveryException)) {
            super.recover(recognizer, e);
        } else {
            // If a 'to' token was found on a new line bubble up the error until we are
            // again in a context where it is allowed to see a 'to' token
            if (
                recognizer.context instanceof ProgramDeclarationContext ||
                recognizer.context instanceof ProgContext ||
                recognizer.context instanceof InputLinesContext
            ) {
                this.endErrorCondition(recognizer);
            } else {
                throw e;
            }
        }
    }

    /*@Override*/
    public recoverInline(recognizer: Parser): any {
        let result = super.recoverInline(recognizer);
        return result;
    }

    protected beginErrorCondition(recognizer: Parser): void {
        super.beginErrorCondition(recognizer);
        this.currProgHasError = true;
        console.log("error in " + this.currentProg);
    }

    /*@Override*/
    public syntaxError<T extends Token>(
        /*@NotNull*/
        recognizer: Recognizer<T, any>,
        offendingSymbol: T | undefined,
        line: number,
        charPositionInLine: number,
        /*@NotNull*/
        msg: string,
        e: RecognitionException | undefined,
    ): void {
        if (recognizer instanceof Parser) {
            recognizer.context;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/xLogoParserErrorStrategy.ts